import { createTheme } from '@mui/material/styles';
const theme = createTheme({
    typography: {
        fontFamily: ['"Montserrat"', 'Open Sans'].join(',')
    }
})

export default theme;